<div class="bg-white text-dark p-4 shadow rounded">
  <div class="message">
    <b>Uppdatering tillgänglig</b><br />
    <p>
      Det finns en ny version av Kundportalen.<br />
      För att använda den nya versionen behöver du klicka på knappen nedan.
    </p>
  </div>
  <div class="message">
    <button class="btn btn-success w-100" (click)="reload()">
      <span>
        UPPDATERA&nbsp;&nbsp;
        <i class="fa-regular fa-sync fa-lg" title="Uppdatera till senaste versionen av Kundportalen"></i>
      </span>
    </button>
  </div>
</div>
